import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import DirectorsContent from './DirectorsContent';
import ShareHoldersContent from './ShareHoldersContent';
import PersonWithSignificantControlContent from './PersonWithSignificantControlContent';
import PeopleSummaryContent from './PeopleSummaryContent';
import usePeopleCredit from '../../hooks/UsePeopleCredit';

import './styles.less';

const { TabPane } = Tabs;

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.people.creditReport';

const CreditReportComponent = ({ query, setQuery, creditReportData }) => {
  const { t: translate } = useTranslation();
  const {
    currentDirectorsLength,
    previousDirectorsLength,
    shareHoldersLength,
    activePersonsWithSignificantControlLength,
    ceasedPersonsWithSignificantControlLength,
  } = usePeopleCredit({ creditReportData });

  return (
    <>
      <PeopleSummaryContent
        currentDirectorsLength={currentDirectorsLength}
        previousDirectorsLength={previousDirectorsLength}
        shareHoldersLength={shareHoldersLength}
        activePersonsWithSignificantControlLength={
          activePersonsWithSignificantControlLength
        }
      />
      <aside className="KYB-people-creditreport">
        <Tabs
          className="wrapper-tabs"
          defaultActiveKey="summary"
          activeKey={query?.subTab}
          onChange={(subTab) => {
            setQuery(() => ({ subTab }));
          }}
          destroyInactiveTabPane
        >
          <TabPane
            tab={translate(`${I18N_BASE_PATH}.tabs.directors.title`, 'Directors')}
            key="directors"
          >
            <DirectorsContent
              currentDirectorsLength={currentDirectorsLength}
              previousDirectorsLength={previousDirectorsLength}
              previousDirectorsList={creditReportData?.previousDirectors ?? []}
              creditReportData={creditReportData}
            />
          </TabPane>
          <TabPane
            tab={translate(`${I18N_BASE_PATH}.tabs.shareholders.title`, 'Shareholders')}
            key="shareholders"
          >
            <ShareHoldersContent
              shareHoldersLength={shareHoldersLength}
              shareholdersList={creditReportData?.shareHolders}
            />
          </TabPane>
          <TabPane
            tab={translate(
              `${I18N_BASE_PATH}.tabs.personWithSignificantControl.title`,
              'PSC/UBO'
            )}
            key="PSCAndUBO"
          >
            <PersonWithSignificantControlContent
              creditReportData={creditReportData}
              activePersonsWithSignificantControlLength={
                activePersonsWithSignificantControlLength
              }
              active={activePersonsWithSignificantControlLength}
              ceased={ceasedPersonsWithSignificantControlLength}
              total={
                activePersonsWithSignificantControlLength +
                ceasedPersonsWithSignificantControlLength
              }
            />
          </TabPane>
        </Tabs>
      </aside>
    </>
  );
};

export default CreditReportComponent;
